import React from 'react';
import styled, {css} from 'styled-components';
import {TransformWrapper, TransformComponent, useControls} from 'react-zoom-pan-pinch';
import useResizeObserver from 'use-resize-observer';

import {ReactComponent as ZoomOut} from '../assets/zoom-out.svg';
import {ReactComponent as ZoomIn} from '../assets/zoom-in.svg';
import {ReactComponent as Reset} from '../assets/reset.svg';

import {DraggablePopup} from './DraggablePopup';
import {Row} from '@bootcamp/web/src/components/Grid';
const HyperlinkImage = styled.div`
  p, img {
    width: auto !important;
    max-width: 100%;
    max-height: ${({tabImg, containerHeight}) => tabImg ? '100%' : `calc(${containerHeight ? `${containerHeight}px` : '80vh'} - 83px)`};
    /* max-height: calc(80vh - 83px); */
    margin: 0;
    height: auto !important;
  }
  p {
    align-self: flex-start;
    width: 90% !important;
    margin: auto;
  }
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  overflow: hidden;
  color: black;
  background: white;

  ${({tableWidth}) => tableWidth && css`width: 100%; max-width: 950px !important; overflow: auto !important; margin: auto; justify-content: flex-start !important; padding: 60px 0px;`}
  ${({videoWidth}) => videoWidth && css`width: 60vw;`};
  ${({useNCLEXTable}) => useNCLEXTable && css`
    table {
      border-spacing: 0;
      border-collapse: collapse;
      min-width: 70% !important;
      margin: 0 !important;
      background: white;
      color: ${({theme}) => theme.colors.neutralsPalette.darkTextColor};
    }
    td {
      padding: 4px;
      position: relative !important;
      border: 1px solid #ddd;
      &:first-child {
        text-align: left;
      }
      p {
        margin: 0;
        width: 100% !important;
      }
    }
    tr {
      &:first-child {
        background: #e8f2ff !important;
        color: initial !important; */
      }

      &:nth-child(even) {
        background: #f2f2f2 !important;
      }
    }
  `}
`;

const ToggleBackground = styled.div`
  background: ${({theme}) => theme.overlays.opacity.light._100};
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
`;
  
const ToggleContainer = styled(Row)`
  padding: 4px;
  position: relative;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex: 0;
  border: 1px solid #EDEDF0;
  border-radius: 8px;
  background: #FAFAFA;
`;

const ToggleTab = styled.div`
  padding: 8px 16px;
  cursor: pointer;
  color: ${({active}) => active ? 'white' : 'black'};
  background: ${({active, theme}) => active ? theme : '#FAFAFA'};
  text-align: center;
  border-radius: 8px;
  transition: all 0.3s;
  white-space: nowrap;
`;


const TabRenderer = ({tabs, close, height, theme}) => {
  const [activeTab, setActiveTab] = React.useState(tabs.findIndex(tab => tab.active));
  return [
    <ToggleBackground>
      <ToggleContainer>
        {tabs.map((tab, index) => (
          <ToggleTab
            key={index}
            onClick={() => setActiveTab(index)}
            active={index === activeTab}
            theme={theme}
          >
            {tab.title}
          </ToggleTab>
        ))}
      </ToggleContainer>
    </ToggleBackground>,
    <TransformComponent
      wrapperStyle={{minHeight: '200px', overflow: 'hidden', width: '100%', height: '100%'}}
      contentStyle={{background: 'url("https://cdnjs.cloudflare.com/ajax/libs/semantic-ui/0.16.1/images/loader-small.gif") no-repeat center', width: '100%', minHeight: '100%', justifyContent: 'center', alignItems: 'center'}}
    >
      <div style={{width: '100%', height: height - 142, background: 'white'}}>
        <HyperlinkImage
          style={{height: `${height - 142}px`}}
          tabImg
          dangerouslySetInnerHTML={{__html: tabs[activeTab].content}}
        />
      </div>
    </TransformComponent>
  ];
};

const TransformControlContainer = styled.div`
  display: flex;
  margin-left: auto;

  button {
    display: flex;
    background: none;
    border: none;
    padding: 0;
    margin-right: 16px;
    font-size: 14px;
    cursor: pointer;
    color: white;

    &:hover {
      color: #FFFF00;
      path {
        fill: #FFFF00;
      }
      rect {
        stroke: #FFFF00;
      }
    }
  }

  svg {
    width: 15px;
    height: 15px;
    margin-right: 4px;
  }

`;
const ZoomOutIcon = styled(ZoomOut)`
`;
const ZoomInIcon = styled(ZoomIn)`
`;
const ResetIcon = styled(Reset)`
`;

const TransformControls = () => {
  const { zoomIn, zoomOut, resetTransform } = useControls();

  return (
    <TransformControlContainer>
      <button onClick={() => zoomIn()}>
        <ZoomInIcon /> Zoom In
      </button>
      <button onClick={() => zoomOut()}>
        <ZoomOutIcon /> Zoom Out
      </button>
      <button onClick={() => resetTransform()}>
        <ResetIcon /> Reset
      </button>
    </TransformControlContainer>
  );
};

const HeaderWrapper = styled.div`
`;

export const HyperlinkRenderer = ({close, associatedHyperlink, theme, headerContent, fixed, useNCLEXTable, hyperlinksRef, isVideo}) => {
  const {ref, height} = useResizeObserver();
  const header = (
    <HeaderWrapper>
      {headerContent || <div>Exhibit: Display</div>}
    </HeaderWrapper>
  );

  if (associatedHyperlink?.includes('class="tab-container"')) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(associatedHyperlink, 'text/html');
    const tabLinks = Array.from(doc.querySelectorAll('.tab-link'));
    const tabContents = Array.from(doc.querySelectorAll('.tab-content'));
    const tabs = tabLinks.map((link, index) => ({
      title: link.innerHTML,
      content: tabContents[index].innerHTML,
      active: link.classList.contains('active') || index == 0
    }));
    return (
      <TransformWrapper doubleClick={{mode: 'reset'}}>
        <DraggablePopup fullSize innerRef={ref} close={close} headerContent={<div>Exhibit: Display</div>} footerContent={<TransformControls/>} color={theme} fixed={fixed}>
          <TabRenderer tabs={tabs} close={close} height={height} theme={theme} />
        </DraggablePopup>
      </TransformWrapper>
    )
  }

  if (associatedHyperlink?.match('<table')) {
    return (
      <DraggablePopup fullSize innerRef={ref} close={close} headerContent={header} footerContent={<div/>} color={theme} fixed={fixed}>
        <HyperlinkImage tableWidth={associatedHyperlink?.match('<table')} containerHeight={height} dangerouslySetInnerHTML={{__html: associatedHyperlink}} className={"fr-view"} useNCLEXTable={useNCLEXTable} />
      </DraggablePopup>
    )
  }
  return (
    <TransformWrapper doubleClick={{mode: 'reset'}} disabled={isVideo} >
      <DraggablePopup fullSize innerRef={ref} close={close} headerContent={header} footerContent={<TransformControls/>} color={theme} fixed={fixed}>
        <TransformComponent
          wrapperStyle={{ minHeight: '200px', overflow: 'hidden', width: '100%', height: '100%', borderLeft: `8px solid ${theme}`, borderRight: `8px solid ${theme}` }}
          contentStyle={{ background: 'url("https://cdnjs.cloudflare.com/ajax/libs/semantic-ui/0.16.1/images/loader-small.gif") no-repeat center', width: '100%', minHeight: '100%', justifyContent: 'center', alignItems: 'center' }}
        >
          <HyperlinkImage ref={hyperlinksRef} videoWidth={isVideo} tableWidth={associatedHyperlink?.startsWith('<table')} containerHeight={height} dangerouslySetInnerHTML={{ __html: associatedHyperlink }} className={"fr-view"} useNCLEXTable={useNCLEXTable} />
        </TransformComponent>
      </DraggablePopup>
    </TransformWrapper>
)}